import { ChangeDetectionStrategy, Component, Input, ViewChild } from "@angular/core";
import {
    BadMoodStreak,
    Reactions,
    ReactionsComponent,
    Threads,
    TimelineItem,
    TimelineItemType
} from "@teammood/timeline";
import { TranslateModule } from "@ngx-translate/core";
import { ThreadsComponent } from "../../../threads/threads.component";
import { UserInfos } from "../../../../shared/ui/username-icon/user-infos.type";
import { ManagerPanelComponent } from "../../manager-panel/manager-panel.component";

@Component({
    selector: "tm-bad-moodstreak",
    templateUrl: "./bad-mood-streak.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        ReactionsComponent,
        ThreadsComponent,
        ManagerPanelComponent
    ]
})
export class BadMoodStreakComponent {

    @Input({required: true})
    badMoodStreak: BadMoodStreak;

    @Input() isOdd: boolean;
    
    @Input() userInfos: UserInfos;

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    protected showThreads: boolean = true;

    protected onThreadsUpdated(timelineItem: TimelineItem & Threads): void {
        if (timelineItem.itemType == "badMoodStreakItem"){
            this.badMoodStreak = timelineItem as BadMoodStreak;
        }
    }

    protected onReacted(timelineItem: {id: string, itemType: TimelineItemType} & Reactions): void {
        if (timelineItem.itemType == "badMoodStreakItem"){
            this.badMoodStreak = timelineItem as BadMoodStreak;
        }
    }

    protected toggleThreads() {
        this.showThreads = !this.showThreads;
    }

    protected discuss() {
        if (this.threadsComponent) {
            this.threadsComponent.discuss = true;
        }
    }

    // fix a race condition by using a function
    getThreadsComponent: () => ThreadsComponent = () => this.threadsComponent;
}